import { Button } from '@/components/ui/button'

interface OnboardingCompleteProps {
    logoSrc: string
    finalCtaLabel: string
    onGetStarted: () => void
}

export const OnboardingComplete = ({ logoSrc, finalCtaLabel, onGetStarted }: OnboardingCompleteProps) => {
    return (
        <div className='flex flex-col items-center gap-8 px-10 text-center py-14'>
            <img src={logoSrc} alt='CommZone logo' className='w-auto h-16' />
            <div className='space-y-3'>
                <h2 className='text-3xl font-semibold text-violet-deepest'>Welcome to CommZone</h2>
                <p className='max-w-md mx-auto text-sm text-violet-support'>
                    Your workspace is ready. The fastest way to get your first brief is to open Persuasion Lab and create a brand baseline.
                </p>
            </div>
            <Button
                type='button'
                onClick={onGetStarted}
                className='rounded-full bg-violet-base px-8 py-3 text-sm font-semibold text-white shadow-[0_14px_30px_rgba(72,28,79,0.2)] transition-colors hover:bg-magenta-rich'
            >
                {finalCtaLabel}
            </Button>
        </div>
    )
}
